import React from 'react';
import {
    Flex, Box, Text, Checkbox, HStack, Badge, Icon, Tooltip, Button,
} from '@chakra-ui/react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { formatarCentavos } from '../formato';

const CANAIS = { site: 'Site', ml: 'Mercado Livre', manual: 'Venda manual' };
const COR_CANAL = { site: 'orange', ml: 'yellow', manual: 'green' };

// Uma venda da aba Pagamentos: selecao (admin), dados e valor da comissao.
const LinhaVendaPagamento = ({ venda, selecionavel, selecionada, onSelecionar, acao }) => (
    <Flex
        px={{ base: 3, md: 4 }}
        py={3}
        gap={3}
        align={{ base: 'flex-start', md: 'center' }}
        bg={selecionada ? 'orange.50' : 'white'}
        transition="background 0.15s"
        _hover={{ bg: selecionada ? 'orange.50' : 'gray.50' }}
        direction={{ base: 'column', md: 'row' }}
    >
        <Flex gap={3} align="center" flex="1" minW={0} w="100%">
            {selecionavel && (
                <Checkbox
                    colorScheme="orange"
                    isChecked={selecionada}
                    onChange={() => onSelecionar(venda.venda_id)}
                    aria-label={`Selecionar venda ${venda.venda_id}`}
                />
            )}
            <Box minW={0} flex="1">
                <HStack spacing={2} flexWrap="wrap">
                    <Text fontWeight="bold" fontSize="sm" color="gray.800">#{venda.venda_id}</Text>
                    {venda.id_origem && <Text fontSize="xs" color="gray.500" noOfLines={1}>{venda.id_origem}</Text>}
                    <Badge colorScheme={COR_CANAL[venda.canal] || 'gray'} variant="subtle" textTransform="none" fontSize="10px" borderRadius="full" px={2}>
                        {CANAIS[venda.canal] || venda.canal}
                    </Badge>
                    {!venda.concluida && (
                        <Tooltip hasArrow label="Venda ainda não concluída. Se for cancelada depois de paga, vira compensação no próximo pagamento." fontSize="xs">
                            <Badge colorScheme="yellow" variant="subtle" textTransform="none" fontSize="10px" borderRadius="full" px={2} cursor="help" tabIndex={0}>
                                <Icon as={FaExclamationTriangle} boxSize="9px" mr={1} />
                                Não concluída
                            </Badge>
                        </Tooltip>
                    )}
                </HStack>
                <Text fontSize="xs" color="gray.500" noOfLines={1} mt={0.5}>
                    {venda.data_formatada}{venda.cliente ? ` · ${venda.cliente}` : ''}
                </Text>
            </Box>
        </Flex>

        <Flex
            gap={{ base: 3, md: 5 }}
            align="center"
            justify={{ base: 'space-between', md: 'flex-end' }}
            w={{ base: '100%', md: 'auto' }}
            pl={{ base: selecionavel ? 7 : 0, md: 0 }}
            flexShrink={0}
        >
            <Box textAlign={{ base: 'left', md: 'right' }}>
                <Text fontSize="10px" color="gray.500" textTransform="uppercase" letterSpacing="wider">Base · %</Text>
                <Text fontSize="xs" color="gray.700">
                    {formatarCentavos(Math.round(Number(venda.valor_base) * 100))} · {Number(venda.percentual).toLocaleString('pt-BR')}%
                </Text>
            </Box>
            <Box textAlign="right" minW="92px">
                <Text fontSize="10px" color="gray.500" textTransform="uppercase" letterSpacing="wider">Comissão</Text>
                <Text fontSize="md" fontWeight="bold" color="gray.800">{formatarCentavos(venda.valor_centavos)}</Text>
            </Box>
            {acao && (
                <Button size="xs" variant="ghost" colorScheme="gray" onClick={acao.onClick} flexShrink={0}>
                    {acao.label}
                </Button>
            )}
        </Flex>
    </Flex>
);

export default LinhaVendaPagamento;
